var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0C7.28416 0 6.94362 0.0115116 5.87701 0.0601777C4.81263 0.108764 4.08569 0.277786 3.44958 0.525007C2.79199 0.780564 2.23432 1.1225 1.67839 1.67843C1.12246 2.23436 0.780524 2.79203 0.524967 3.44962C0.277746 4.08569 0.108725 4.81263 0.060138 5.87701C0.0114719 6.94362 0 7.28416 0 10C0 12.7158 0.0114719 13.0564 0.060138 14.123C0.108725 15.1874 0.277746 15.9143 0.524967 16.5504C0.780524 17.208 1.12246 17.7656 1.67839 18.3216C2.23432 18.8775 2.79199 19.2195 3.44958 19.475C4.08569 19.7222 4.81263 19.8913 5.87701 19.9398C6.94362 19.9885 7.28416 20 10 20C12.7158 20 13.0564 19.9885 14.123 19.9398C15.1874 19.8913 15.9143 19.7222 16.5504 19.475C17.208 19.2195 17.7656 18.8775 18.3216 18.3216C18.8775 17.7656 19.2195 17.208 19.475 16.5504C19.7222 15.9143 19.8913 15.1874 19.9398 14.123C19.9885 13.0564 20 12.7158 20 10C20 7.28416 19.9885 6.94362 19.9398 5.87701C19.8913 4.81263 19.7222 4.08569 19.475 3.44962C19.2195 2.79203 18.8775 2.23436 18.3216 1.67843C17.7656 1.1225 17.208 0.780564 16.5504 0.525007C15.9143 0.277786 15.1874 0.108764 14.123 0.0601777C13.0564 0.0115116 12.7158 0 10 0ZM10 1.80184C12.6701 1.80184 12.9864 1.812 14.0409 1.86011C15.0158 1.90461 15.5453 2.06752 15.8977 2.20443C16.3645 2.38583 16.6976 2.60257 17.0475 2.95248C17.3975 3.30239 17.6142 3.63555 17.7956 4.10229C17.9325 4.45466 18.0954 4.98415 18.1399 5.95914C18.188 7.0136 18.1982 7.32989 18.1982 10C18.1982 12.6701 18.188 12.9864 18.1399 14.0409C18.0954 15.0158 17.9325 15.5453 17.7956 15.8977C17.6142 16.3645 17.3975 16.6976 17.0475 17.0475C16.6976 17.3975 16.3645 17.6142 15.8977 17.7956C15.5453 17.9325 15.0158 18.0954 14.0409 18.1399C12.9866 18.188 12.6703 18.1982 10 18.1982C7.32969 18.1982 7.01348 18.188 5.95914 18.1399C4.98415 18.0954 4.45466 17.9325 4.10229 17.7956C3.63551 17.6142 3.30239 17.3975 2.95244 17.0475C2.60253 16.6976 2.38579 16.3645 2.20443 15.8977C2.06748 15.5453 1.90457 15.0158 1.86007 14.0409C1.81196 12.9864 1.8018 12.6701 1.8018 10C1.8018 7.32989 1.81196 7.0136 1.86007 5.95914C1.90457 4.98415 2.06748 4.45466 2.20443 4.10229C2.38579 3.63555 2.60253 3.30239 2.95244 2.95248C3.30239 2.60257 3.63551 2.38583 4.10229 2.20443C4.45466 2.06752 4.98415 1.90461 5.95914 1.86011C7.0136 1.812 7.32989 1.80184 10 1.80184Z",
    fill: "url(#paint0_linear_763_5376)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 13.3333C8.15904 13.3333 6.66667 11.841 6.66667 10C6.66667 8.15904 8.15904 6.66667 10 6.66667C11.841 6.66667 13.3333 8.15904 13.3333 10C13.3333 11.841 11.841 13.3333 10 13.3333ZM10 4.86487C7.16393 4.86487 4.86487 7.16393 4.86487 10C4.86487 12.8361 7.16393 15.1351 10 15.1351C12.8361 15.1351 15.1351 12.8361 15.1351 10C15.1351 7.16393 12.8361 4.86487 10 4.86487Z",
    fill: "url(#paint1_linear_763_5376)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.538 4.66199C16.538 5.32473 16.0008 5.86197 15.338 5.86197C14.6753 5.86197 14.138 5.32473 14.138 4.66199C14.138 3.99924 14.6753 3.462 15.338 3.462C16.0008 3.462 16.538 3.99924 16.538 4.66199Z",
    fill: "url(#paint2_linear_763_5376)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_763_5376",
    x1: 0,
    y1: 10,
    x2: 20,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3D3D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_763_5376",
    x1: 0,
    y1: 10,
    x2: 20,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3D3D3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_763_5376",
    x1: 0,
    y1: 10,
    x2: 20,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D3D3D3"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.17f32609b33a63fe653255bccfdf0ba9.svg";
export { ForwardRef as ReactComponent };